import { render, staticRenderFns } from "./call-ringing-dialog.vue?vue&type=template&id=4ab44da5&scoped=true&"
import script from "./call-ringing-dialog.vue?vue&type=script&lang=js&"
export * from "./call-ringing-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab44da5",
  null
  
)

export default component.exports